import { configureStore } from '@reduxjs/toolkit';

import feedbackReducer from '../slices/feedbackSlice';
import customersReducer from '../slices/customersSlice';
import itemsReducer from '../slices/itemsSlice';
import authReducer from '../slices/authSlice';
import organizationReducer from '../slices/organizationSlice';

// Every reducer must be included here to be accessible by the useSelector hook
const reducer = {
  auth: authReducer,
  items: itemsReducer,
  customers: customersReducer,
  feedback: feedbackReducer,
  organization: organizationReducer,
};

const store = configureStore({
  // RTK 2 a SUPPRIMÉ l'export `getDefaultMiddleware` : la fonction est
  // désormais passée en argument de `middleware`, ce qui garantit qu'on part
  // bien de la pile par défaut au lieu de la remplacer par accident.
  //
  // `serializableCheck: false` est conservé tel quel : le contrôle refusait
  // les objets `File` que porte l'envoi d'une couverture, et il ne s'agit pas
  // de changer ce comportement en même temps qu'on change de version.
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
  reducer,
  devTools: true,
});

export default store;
